import React from 'react'
// c:\xampp\htdocs\miners-market-main\components\BankingDetailsForm.js

export default function BankingDetailsForm({ user, onUserUpdate }) {
    const [details, setDetails] = React.useState({
        bank_name: user.bank_name || '',
        account_holder_name: user.account_holder_name || '',
        account_number: user.account_number || '',
        branch_code: user.branch_code || '',
        account_type: user.account_type || 'cheque',
    });
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(null);

    // This effect keeps the form's state in sync if the parent user object changes.
    React.useEffect(() => {
        setDetails({
            bank_name: user.bank_name || '',
            account_holder_name: user.account_holder_name || '',
            account_number: user.account_number || '',
            branch_code: user.branch_code || '',
            account_type: user.account_type || 'cheque',
        });
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);
        setSuccess(null);

        try {
            const response = await fetch('/api/update_banking_details.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(details)
            });

            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || 'An unknown error occurred.');
            }

            setSuccess(result.message);
            // Call the parent's update function to keep the main user state in sync
            onUserUpdate(details);

        } catch (err) {
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-6 mt-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Banking Details for Payouts</h2>
            <p className="text-sm text-gray-500 mb-4">This information is required for us to pay you for your sales. It is kept confidential and secure.</p>
            <p className="text-sm text-gray-500 mb-4">
                Miners Market does not store banking information as per our <a href="/miners-market-main/documents/footer/Miners Market Privacy Policy.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">privacy policy</a>, so when you log out it will clear your banking details.
            </p>
            
            {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm mb-4">{error}</div>}
            {success && <div className="bg-green-100 text-green-700 p-3 rounded-lg text-sm mb-4">{success}</div>}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Bank Name*</label>
                        <input type="text" name="bank_name" value={details.bank_name} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Account Holder Name*</label>
                        <input type="text" name="account_holder_name" value={details.account_holder_name} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="As it appears on your statement" />
                    </div>
                </div>
                <div className="grid md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Account Number*</label>
                        <input type="text" name="account_number" value={details.account_number} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Branch Code*</label>
                        <input type="text" name="branch_code" value={details.branch_code} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Account Type*</label>
                        <select name="account_type" value={details.account_type} onChange={handleChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm">
                            <option value="cheque">Cheque / Current</option>
                            <option value="savings">Savings</option>
                            <option value="transmission">Transmission</option>
                        </select>
                    </div>
                </div>
                <div className="flex justify-end pt-4">
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="primary-gradient text-white py-2 px-6 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50"
                    >
                        {isSubmitting ? 'Saving...' : 'Save Banking Details'}
                    </button>
                </div>
            </form>
        </div>
    );
}
